export const removeHtmlTags = (html: string) => html.replace(/<[^>]*>/g, "");
